// Mock data for Legal Brand Hub clone

export const services = [
  {
    id: 'trademark',
    title: 'Trademark Registration',
    description: 'Register your trademark with confidence and secure exclusive rights to your brand identity.',
    icon: 'Shield',
    link: '/services/trademark'
  },
  {
    id: 'copyright',
    title: 'Copyright Registration',
    description: 'Protect your original creative works through expert copyright registration services.',
    icon: 'FileText',
    link: '/services/copyright'
  },
  {
    id: 'patent',
    title: 'Patent Services',
    description: 'Secure your innovations with comprehensive patent search, application, and enforcement.',
    icon: 'Lightbulb',
    link: '/services/patent'
  },
  {
    id: 'company',
    title: 'Company Formation',
    description: 'Establish your business with proper legal structure—LLC, Corporation, or Non-Profit.',
    icon: 'Building',
    link: '/services/company-formation'
  }
];

export const pricingPlans = [
  {
    id: 'essentials',
    name: 'Essentials',
    price: 49,
    popular: false,
    description: 'Perfect for first-time trademark filers',
    features: [
      'Case Review & Assessment',
      'Basic Trademark Search',
      'USPTO Filing Assistance',
      'Trademark Monitoring (1 Month)',
      'Email Support',
      'Attorney Pre-Filing Letter',
      'Trademark Secured'
    ]
  },
  {
    id: 'standard',
    name: 'Standard',
    price: 149,
    popular: true,
    description: 'Ideal for growing businesses',
    features: [
      'Everything in Essentials',
      'Expert Case Review',
      'Comprehensive Trademark Search',
      'Trademark Monitoring (3 Months)',
      'Risk Evaluation Report',
      'Cease & Desist Template',
      'Dedicated Account Manager',
      '100% Approval Guarantee'
    ]
  },
  {
    id: 'professional',
    name: 'Professional',
    price: 299,
    popular: false,
    description: 'Complete protection for established brands',
    features: [
      'Everything in Standard',
      'Attorney Review & Filing',
      '24-Hour Expedited Processing',
      'Trademark Monitoring (12 Months)',
      'Comprehensive Search (50 States)',
      'Office Action Support',
      'Opposition & Litigation Advice',
      '100% Approval Guarantee'
    ]
  },
  {
    id: 'premium',
    name: 'Premium',
    price: 899,
    popular: false,
    description: 'Maximum protection & premium service',
    features: [
      'Everything in Professional',
      'Direct Attorney Assignment',
      'Trademark Monitoring (24 Months)',
      'International Trademark Support',
      '24/7 Secure Portal Access',
      'Complete Opposition Management',
      'White Glove Service',
      '100% Approval Guarantee'
    ]
  }
];

export const lpPricingPlans = [
  {
    id: 'essentials',
    name: 'Essentials',
    price: 45,
    popular: false,
    description: 'Basic trademark filing service',
    features: [
      'Case Review',
      'Basic Trademark Search',
      'Trademark Secured',
      '24/7 Secure Online Access',
      'Cease & Desist Letter Template',
      'Free Infringement Alerts (1 Month)'
    ]
  },
  {
    id: 'enhanced',
    name: 'Enhanced',
    price: 149,
    popular: true,
    description: 'Enhanced filing with comprehensive search',
    features: [
      'Case Review by TM Expert',
      'Trademark Monitoring (3 Months)',
      '24-Hour Expedited Processing',
      'Trademark Secured',
      'Attorney Pre-Filing Letter',
      'Free Infringement Alerts (1 Month)',
      'Dedicated Client Relations Attorney'
    ]
  },
  {
    id: 'elite',
    name: 'Elite',
    price: 299,
    popular: false,
    description: 'Comprehensive filing with full legal support',
    features: [
      'Attorney Case Review & Filing',
      'Trademark Monitoring (12 Months)',
      'Direct Hit Search',
      'Refusal Risk Evaluation',
      'Comprehensive Search (50 States + Social Media/Domains)',
      'Litigant Scan',
      'Opposition & Litigation Support',
      'Dedicated Attorney',
      '100% Approval Guaranteed'
    ]
  },
  {
    id: 'exclusive',
    name: 'Exclusive',
    price: 899,
    popular: false,
    description: 'The most comprehensive trademark protection',
    features: [
      'Everything in Elite',
      'Trademark Monitoring (12 Months)',
      'Complete Paperwork Filing',
      'International Trademark Assistance',
      'Global Risk Assessment (100+ Countries)',
      'Free Infringement Alerts (3 Months)',
      'Priority Legal Support',
      '100% Approval Guarantee'
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Priya Sharma',
    role: 'Entrepreneur, Wellness Co.',
    image: 'https://images.pexels.com/photos/762020/pexels-photo-762020.jpeg',
    content: 'I needed comprehensive trademark monitoring for my growing wellness brand. Trademark Essential\'s proactive approach caught potential conflicts early and saved me from costly disputes. Invaluable service!'
  },
  {
    id: 2,
    name: 'Sarah Mitchell',
    role: 'CEO, TechNova Solutions',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHxlbnwwfHx8fDE3NjA3NjAzNTd8MA&ixlib=rb-4.1.0&q=85',
    content: 'Trademark Essential made our brand registration process seamless. Their attention to detail and expert guidance gave us complete confidence in protecting our intellectual property. Highly recommend their services!'
  },
  {
    id: 3,
    name: 'Marcus Johnson',
    role: 'Founder, Urban Threads Apparel',
    image: 'https://images.unsplash.com/photo-1629425733761-caae3b5f2e50?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHxlbnwwfHx8fDE3NjA3NjAzNTd8MA&ixlib=rb-4.1.0&q=85',
    content: 'As an Amazon seller, protecting my brand was crucial. The team at Trademark Essential handled everything from trademark registration to Brand Registry enrollment. Professional, fast, and affordable!'
  },
  {
    id: 4,
    name: 'David Chen',
    role: 'CTO, Innovate Labs',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHxlbnwwfHx8fDE3NjA3NjAzNTd8MA&ixlib=rb-4.1.0&q=85',
    content: 'Their patent services exceeded our expectations. The attorneys are knowledgeable, responsive, and truly care about protecting your innovations. We\'ve secured three patents with their help!'
  },
  {
    id: 5,
    name: 'Jennifer Lopez',
    role: 'Creative Director, Artisan Collective',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw1fHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHxlbnwwfHx8fDE3NjA3NjAzNTd8MA&ixlib=rb-4.1.0&q=85',
    content: 'Copyright protection for our creative work was essential. The team handled everything efficiently, from registration to enforcement. Their expertise gave us peace of mind to focus on creating!'
  }
];

export const lpTestimonials = [
  {
    id: 1,
    name: 'Amanda R.',
    role: 'eCommerce Seller',
    content: 'Trademark Essential made the whole process seamless! I got my approval in weeks and felt confident every step of the way.'
  },
  {
    id: 2,
    name: 'Michael T.',
    role: 'Tech Startup Founder',
    content: 'The attorneys were knowledgeable and responsive. They handled everything from search to filing. Highly recommend!'
  },
  {
    id: 3,
    name: 'Sarah L.',
    role: 'Small Business Owner',
    content: 'Transparent pricing and excellent service. They protected my brand name and helped me register on Amazon Brand Registry.'
  },
  {
    id: 4,
    name: 'James K.',
    role: 'Restaurant Owner',
    content: 'Outstanding service from start to finish. Their team guided me through every step and ensured my restaurant brand was fully protected.'
  },
  {
    id: 5,
    name: 'Emily W.',
    role: 'Fashion Designer',
    content: 'Professional and efficient! They secured my fashion brand trademark quickly and provided ongoing support. Couldn\'t be happier!'
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: 'Legal Excellence',
    description: 'Top-tier legal expertise in all aspects of intellectual property law.',
    icon: 'Scale'
  },
  {
    id: 2,
    title: 'Client-Focused',
    description: 'Personalized service tailored to your unique business needs.',
    icon: 'Users'
  },
  {
    id: 3,
    title: 'Proven Results',
    description: 'Consistent track record of successful filings and registrations.',
    icon: 'Award'
  },
  {
    id: 4,
    title: 'Growth Partners',
    description: 'Supporting your business growth with comprehensive IP strategies.',
    icon: 'TrendingUp'
  }
];

export const whyChooseUsDetailed = [
  {
    id: 1,
    title: 'Experienced IP Attorneys',
    description: 'Decades of combined experience in intellectual property law and brand protection.',
    icon: 'Briefcase'
  },
  {
    id: 2,
    title: 'Transparent Pricing',
    description: 'Clear, upfront pricing with no hidden fees. Know exactly what you\'re paying for.',
    icon: 'DollarSign'
  },
  {
    id: 3,
    title: 'Fast & Reliable Filings',
    description: 'Quick turnaround times without compromising quality or legal precision.',
    icon: 'Zap'
  },
  {
    id: 4,
    title: 'End-to-End Legal Support',
    description: 'Comprehensive support from initial consultation through registration and beyond.',
    icon: 'LifeBuoy'
  }
];

export const lpBenefits = [
  {
    id: 1,
    title: 'Legal Ownership',
    description: 'Prevent others from using your brand name or logo. Establish exclusive rights nationwide.',
    icon: 'Shield'
  },
  {
    id: 2,
    title: 'Brand Credibility',
    description: 'Build legal ownership and brand credibility that customers and investors trust.',
    icon: 'CheckCircle'
  },
  {
    id: 3,
    title: 'Amazon & eCommerce Protection',
    description: 'Protect your brand on Amazon, eCommerce platforms, and enroll in Amazon Brand Registry.',
    icon: 'ShoppingCart'
  },
  {
    id: 4,
    title: 'Federal Law Protection',
    description: 'Gain exclusive nationwide rights under federal law with USPTO registration.',
    icon: 'Flag'
  },
  {
    id: 5,
    title: 'Business Valuation',
    description: 'Increase your business\'s valuation and investor trust with registered IP assets.',
    icon: 'TrendingUp'
  },
  {
    id: 6,
    title: 'Legal Enforcement',
    description: 'Sue infringers and seek damages in federal court with registered trademark rights.',
    icon: 'Gavel'
  }
];

export const lpWhyTrust = [
  {
    id: 1,
    title: 'Experienced IP Attorneys',
    description: 'Decades of combined expertise in U.S. trademark law and intellectual property.',
    icon: 'Briefcase'
  },
  {
    id: 2,
    title: 'Fast Filing Process',
    description: 'Quick turnaround, status tracking, and 24-hour expedited options available.',
    icon: 'Clock'
  },
  {
    id: 3,
    title: 'Transparent Pricing',
    description: 'No hidden costs — clear and upfront fees with flat-rate pricing packages.',
    icon: 'DollarSign'
  },
  {
    id: 4,
    title: 'Full Legal Support',
    description: 'From search to registration to enforcement — complete trademark protection.',
    icon: 'Shield'
  }
];

export const howItWorks = [
  {
    id: 1,
    title: 'Provide Your Trademark Details',
    description: 'Share your trademark information, including the name, logo, and intended use. Our team will review your submission to ensure we have everything needed to move forward.',
    icon: 'FileText'
  },
  {
    id: 2,
    title: 'Choose Your Service and Complete Payment',
    description: 'Select the protection package that best fits your needs from our transparent pricing options. Complete your secure payment to begin the registration process.',
    icon: 'CreditCard'
  },
  {
    id: 3,
    title: 'Comprehensive Evaluation and Filing',
    description: 'Our experienced IP attorneys conduct a thorough evaluation, prepare your application with precision, and file it with the appropriate trademark office on your behalf.',
    icon: 'CheckCircle'
  }
];

export const lpProcess = [
  {
    id: 1,
    title: 'Search & Review',
    description: 'We conduct a comprehensive trademark search and review to identify potential conflicts and ensure your brand is protected.',
    icon: 'Search'
  },
  {
    id: 2,
    title: 'Prepare & File',
    description: 'Our licensed attorneys prepare and file your complete USPTO trademark application with precision.',
    icon: 'FileCheck'
  },
  {
    id: 3,
    title: 'Approval & Protection',
    description: 'Track your application progress and receive your official trademark registration certificate from the USPTO.',
    icon: 'Award'
  }
];